import React from 'react';
import { Link} from 'react-router-dom';
import { useState } from 'react';
import Hamburger from './Hamburger';
// import Home from './Home'
// import LookBook from './lookBook';
// import CreateAppt from './createAppt';
import logo from '../images/Logo-black.png'
import Instagram from '../images/Instagram_Glyph_Gradient.png'
import Facebook from '../images/Facebook_Logo_Primary.png'


const Navbar=()=>{
                const [ hamburgerOpen, setHamburgerOpen ] = useState(false);
                
                // const CloseMenu = () =>{
                // const {path} = useLocation();
                // useEffect(() => {
                //     setHamburgerOpen(false);
                // }, [path]) 
                // return ()=>{
                //     const currentState = !hamburgerOpen;
                // }
                // }

            const toggleHamburger = () => {
                setHamburgerOpen(!hamburgerOpen);
            }
    return(
        <div className='navBurger'>
            <div className='hamburger' onClick={toggleHamburger} >
         <Hamburger />
         </div> 

    <div className='trial'>
        <div className='navlogodiv'>
                            {/* <img className='navLogo' src={logo} alt='Raili Custom Bridal Logo'></img> */}
            <Link to='/'>
            <img className='navLogo' src={logo} alt='Raili Custom Bridal Logo'></img>
            </Link>
            </div>
    <nav className='navbar'>



            <div className='divLinks'>
            <Link to='/' className='navLink' onClick={toggleHamburger}>Home</Link>
        
            <Link to='/ourBrides' className='navLink' onClick={toggleHamburger}>Our Brides</Link>
        
            <Link to='/schedule' className='navLink' onClick={toggleHamburger}>Schedule a Consultation</Link>

            <Link to='/aboutRaili' className='navLink' onClick={toggleHamburger}>About Raili</Link>
            </div>
            <div className='socialMedia'>
                <a href='https://www.instagram.com/raili_custom_bridal/'><img className='instagramLogo' src={Instagram} alt='Instagram Logo'></img></a>
                <a href='https://www.facebook.com/p/Raili-Custom-Bridal-61580348456983/'><img className='facebookLogo' src={Facebook} alt='Facebook Logo'></img></a>
            </div>
            
    </nav>
    </div>
    
    {/* <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/ourBrides' element={<LookBook />}/>
        <Route path='/createAppt' element={<CreateAppt />}/>
    </Routes> */}


            <style jsx>{`
            @media only screen and (max-width: 640px) {
            .navbar{
                display: ${hamburgerOpen ? 'inline' : 'none'};
            }
            }
            `}</style> 

    </div>
    )
}

export default Navbar;